import api, { handleAPIErrors } from 'shared/api'
import { errorMessage } from 'shared/errorMessage'

const FETCH_REQUEST = 'companyRanking/FETCH_REQUEST'
const FETCH_SUCCESS = 'companyRanking/FETCH_SUCCESS'
const FETCH_FAILURE = 'companyRanking/FETCH_FAILURE'

const initialState = {
  result: {},
  loaded: false,
  loading: false,
  errors: []
}

export function fetchRequest(payload = {}) {
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload) {
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function loadRanking(options = {}) {
  return (dispatch, getState) => {
    const state = getState()
    dispatch(fetchRequest())

    const promise = api(`api/v1/companies/ranking`, options, {}, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          if(errors){
            dispatch(fetchFailure(errors))
          } else {
            dispatch(fetchFailure([errorMessage]))
          }
        })
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action

  switch (type) {
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true
      })
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        errors: [],
        result: payload
      })
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: true,
        result: {
          ...state.result,
          errors: payload
        }
      }
    default:
      return state
  }
}

